import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';

import useStyles from './useStyles';

export const ErrorMessage = ({ className, error, ...restProps }) => {
  const styles = useStyles();

  return error ? (
    <Typography className={cx(styles.root, className)} {...restProps}>
      {error}
    </Typography>
  ) : null;
};

ErrorMessage.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
};

ErrorMessage.defaultProps = {
  className: null,
  error: null,
};
